export default {
    variant
}

function variant(status = '') {
    const value = String(status).toLowerCase()

    if (value.includes('entregado') || value.includes('finalizado') || value.includes('resuelto')) {
        return 'success'
    }

    if (
        value.includes('cancelado') ||
        value.includes('reembols') ||
        value.includes('fallid')
    ) {
        return 'danger'
    }

    if (
        value.includes('camino') ||
        value.includes('revisión') ||
        value.includes('revision') ||
        value.includes('sin movimiento') ||
        value.includes('generada')
    ) {
        return 'warning'
    }

    if (value.includes('pendiente') || value.includes('no usada')) {
        return 'info'
    }

    return 'neutral'
}
